// extracted by mini-css-extract-plugin
module.exports = {"not-for-sell":"not-for-sell--3Jzp8"};